<ngx-simplebar
  *ngIf="this.config['layout'] === 'vertical'"
  [exclude]="'#mobile-collapse1'"
  (clickOutside)="navMob()"
  id="nav-ps-datta"
  ngClass="datta-scroll"
  [style.max-width]="'300px'"
  [style.max-height]="'calc(100vh - 70px)'"
  [usePSClass]="'datta'"
  [disabled]="null"
  [autoPropagation]="true"
>
  <div class="navbar-content">
    <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()" (mouseleave)="navMob()">
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type == 'group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type == 'collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type == 'item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
  </div>
</ngx-simplebar>
<div *ngIf="this.config['layout'] === 'horizontal'" class="navbar-content sidenav-horizontal" id="layout-sidenav">
  <a href="javascript:" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
  <div #navbarWrapper class="sidenav-horizontal-wrapper">
    <!-- add 14-4 viral -->
    <ul
      #navbarContent
      id="side-nav-horizontal"
      class="nav pcoded-inner-navbar sidenav-inner"
      (clickOutside)="fireLeave()"
      (mouseleave)="fireLeave()"
    >
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type == 'group'" [item]="item"></app-nav-group>
        <app-nav-collapse *ngIf="item.type == 'collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type == 'item'" [item]="item"></app-nav-item>
      </ng-container>
    </ul>
  </div>
  <a href="javascript:" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
</div>
